import { ExplorerClosedSilosPro } from './variants/silospro-closed-explorer';
import { ExplorerWithoutVRR } from './variants/silospro-without-vrr-explorer';
import { ExplorerVRR } from './variants/silospro-vrr-explorer';
import { ExplorerActiveSilobag } from './variants/silobag-active-explorer';
import { ExplorerArchivedSilobag } from './variants/silobag-archived-explorer';
import { ExplorerClosedSilobag } from './variants/silobag-closed-explorer';

export const EXPLORER = {
  SILOS_PRO: {
    VRR: ExplorerVRR,
    WITHOUT_VRR: ExplorerWithoutVRR,
    CLOSED: ExplorerClosedSilosPro,
  },
  SILOBAG: {
    ACTIVE: ExplorerActiveSilobag,
    CLOSED: ExplorerClosedSilobag,
    ARCHIVED: ExplorerArchivedSilobag,
  },
} as const;
